import { MouseEventHandler, ReactNode } from 'react';
import { ToastProps } from '../Toast';
import { IconElement } from '../common';

export type NavigationToastProps = Omit<ToastProps, 'role' | 'children'> & {
  /** Content to display in the toast. */
  children: ReactNode;
  /**
   * Custom icon displayed at the start of the toast content.
   *
   * @default `<Icons.ArrowBentUpLeft />`
   */
  prefixIcon?: IconElement | false;
  /** Callback triggered when the toast action is performed. */
  onAction?: MouseEventHandler<HTMLDivElement>;
  /** Time in milliseconds before the toast dismisses automatically. When set to `0` or `null`, the toast remains indefinitely.
   *
   * @default 0
   */
  duration?: number | null;
};
